<template>
  <!-- <el-breadcrumb separator=">" class="breadcrumb-box">
    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
    <template v-for="(item, index) in breadList">
      <el-breadcrumb-item v-if="item.meta.title" :key="index" :to="item.path">{{
        item.meta.title
      }}</el-breadcrumb-item>
    </template>
  </el-breadcrumb> -->
  <van-config-provider :theme-vars="themeVars">
    <router-view v-if="$route.meta.keepAlive" v-slot="{ Component }">
      <transition name="fade-transform" mode="out-in">
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      </transition>
    </router-view>
    <router-view v-else></router-view>
  </van-config-provider>
</template>
<script>
import api from './api'
import { provide, onBeforeMount, ref } from 'vue'
import utils from './assets/js/utils'
import { useRoute, useRouter } from 'vue-router'
import { ConfigProvider } from 'vant'
export default {
  name: 'App',
  components: { [ConfigProvider.name]: ConfigProvider },
  setup () {
    const route = useRoute()
    const router = useRouter()
    provide('$api', api)
    provide('$utils', utils)
    const breadList = ref([])
    onBeforeMount(() => {
    })
    router.afterEach(() => {
      breadList.value = route.matched
    })

    return {
      breadList,
      themeVars: {
        buttonPrimaryBackgroundColor: '#0f5293',
        buttonPrimaryBorderColor: '#0f5293',
        calendarSelectedDayBackgroundColor: '#0f5293'
      }
    }
  }
}
</script>

<style>
#vue-app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 50vh;
  background-color: #fff;
  width: 100%;
}
body {
  margin: 0px auto;
  max-width: 1200px;
  background: none !important;
}
html {
  background-color: #f7f7f7;
  font-size: 16px;
}
</style>
<style lang="less" scoped>
.breadcrumb-box {
  margin: 0px auto;
  margin-top: 18px;
  max-width: 1200px;
  min-width: 980px;
}
</style>
